import axios from "axios";

// Create an instance of Axios with baseURL and withCredentials
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  
});

export default axiosInstance